import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';


export interface SelectFromListData {
  title: string;
  items: SelectFromListModel[];
}

export interface SelectFromListModel {
  display: string;
  selected: boolean;
  value: any;
}

export interface SelectFromListResult {
  result: 'cancel' | 'select' | 'reset';
  selectedItems: SelectFromListModel[];
}

@Component({
  selector: 'app-select-from-list-dialog',
  standalone: false,
  templateUrl: './select-from-list-dialog.component.html',
  styleUrl: './select-from-list-dialog.component.scss'
})
export class SelectFromListDialogComponent implements OnInit {

  @ViewChild(MatSelectionList, { static: true }) selectionList: MatSelectionList;

  selectedItems: SelectionModel<SelectFromListModel> = new SelectionModel<SelectFromListModel>(true);
  result: SelectFromListModel[] = [];

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    public dialogRef: MatDialogRef<SelectFromListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectFromListData
  ) { }

  ngOnInit(): void {
    this.data.items.forEach(item => {
      if (item.selected) {
        this.selectedItems.select(item);
        this.result.push(item);
      }
    });
  }

  change(event: MatSelectionListChange) {
    const selectedItem = event.options[0].value;
    this.selectedItems.toggle(selectedItem);
    this.result = this.selectedItems.selected;
  }

  isSelected(item: SelectFromListModel): boolean {
    return this.selectedItems.isSelected(item);
  }

  onClose(result: 'reset' | 'cancel' | 'select'): void {
    this.dialogRef.close({ result, selectedItems: this.result });
  }
}
